"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var State = /** @class */ (function () {
    // set depId
    function State(depId) {
        this.activated = false;
        // is the chat available
        this.available = false;
        // depId for optimize-it; 4 - search
        this.depId = 4;
        // is the chat loaded, loading must not called more than once
        this.loaded = false;
        // has the conversion been tracked, must not called more than once
        this.tracked = false;
        depId ? (this.depId = depId) : (this.depId = 4);
    }
    return State;
}());
exports.State = State;
//# sourceMappingURL=state.js.map